// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
// Actions
import { removeFundChartLineAnnotation, setFundChartLineAnnotation, setFundChartLineAnnotations, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/line-annotations/line-annotations.actions';
import { removeFundChartSecurity } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const lineAnnotations = createReducer({}, on(setChartData, (state, { chartData }) => chartData.params.lineAnnotations), on(setFundChartLineAnnotations, (state, action) => action.lineAnnotations), on(setFundChartLineAnnotation, (state, action) => {
    const newState = cloneDeep(state);
    // If we are missing security and calc, add both
    if (!state[action.securityId]) {
        newState[action.securityId] = {
            [action.calcId]: action.lineAnnotation,
        };
        // Otherwise, set calcId to new line annotation state
    }
    else {
        newState[action.securityId] = {
            ...newState[action.securityId],
            [action.calcId]: action.lineAnnotation,
        };
    }
    return newState;
}), on(removeFundChartLineAnnotation, (state, action) => {
    const newState = cloneDeep(state);
    // If we don't at least have a securityId key, do not try to delete
    if (!state[action.securityId])
        return newState;
    delete newState[action.securityId][action.calcId];
    // If the security has no more calcs / line annotations, remove it from line annotation state
    if (Object.keys(newState[action.securityId]).length === 0) {
        delete newState[action.securityId];
    }
    return newState;
}), on(removeFundChartSecurity, (state, action) => {
    const newState = cloneDeep(state);
    delete newState[action.fundChartSecurity.id];
    return newState;
}));
